import clsx from "clsx";

export function cn(...inputs: string[]) {
  return clsx(inputs);
}
